import styled from "@emotion/styled";
import { BORDER_STYLE } from "../risk/bottombar/AdditionalActionsStyle";

/**
 * A container for opacity actions, including modify the overall opacity
 * and disabling individual impact layers
 */
export const MapStyleSelectorContainer = styled( "div" )( {
    display: "flex",
    flexDirection: "column",
    border: BORDER_STYLE,
    borderRadius: "10px",
    background: "white",
    margin: "20px 20px 20px 20px",
    width: "fit-content"
} );
